export const PAYMENT_PURPOSES_MOCK = {
  ACM: 'Agency Commissions',
  AES: 'Advance payment against EOS',
  AFA: 'Receipts or payments from personal residents bank account or deposits abroad',
  AFL: 'Receipts or payments from personal non-residents bank account in the UAE',
  ALW: 'Allowance',
  ATS: 'Air transport',
  BON: 'Bonus',
  CCP: 'Corporate Card Payments',
  CEA: 'Equity and investment fund shares for the establishment of new company from residents abroad, equity of merger or acquisition of companies abroad from residents and participation to capital increase of related companies abroad',
  CEL: 'Equity and investment fund shares for the establishment of new company in the UAE from non- residents, equity of merger or acquisition of companies in the UAE from non-residents and participation to capital increase of related companies from non-residents in the UAE',
  CHC: 'Charitable Contributions (Charity and Aid)',
  CIN: 'Commercial Investments',
  COM: 'Commission',
  COP: 'Compensation',
  DCP: 'Debit Card Payments',
  DIF: 'Debt instruments intragroup loans securities deposits foreign',
  DIL: 'Debt instruments intragroup loans securities deposits UAE',
  DLA: 'Purchases and sales of foreign debt securities in not related companies – More than a year',
  DLF: 'Debt instruments intragroup loans, deposits foreign (above 10% share)',
  DLL: 'Purchases and sales of securities issued by residents in not related companies – More than a year',
  DOE: 'Dividends on equity not intragroup',
  DSA: 'Purchases and sales of foreign debt securities in not related companies – Less than a year',
  DSF: 'Debt instruments intragroup foreign securities',
  DSL: 'Purchases and sales of securities issued by residents in not related companies – Less than a year',
  EDU: 'Educational Support',
  EMI: 'Equated Monthly Instalments',
  EOS: 'End of Service / Final Settlement',
  FDA: 'Financial derivatives foreign',
  FDL: 'Financial derivatives in the UAE',
  FIA: 'Investment fund shared foreign',
  FIL: 'Investment fund shared in the UAE',
  FIS: 'Financial services',
  FSA: 'Equity other than investment fund shares in not related companies abroad',
  FSL: 'Equity other than investment fund shares in not related companies in the UAE',
  GDE: 'Goods sold (Exports in FOB value)',
  GDI: 'Goods bought (Imports in CIF value)',
  GDS: 'Goods Bought or Sold',
  GMS: 'Processing repair and maintenance services on goods',
  GOS: 'Government goods and services embassies etc',
  GRI: 'Government related income taxes, tariffs, capital transfers, etc.',
  IFS: 'Information services',
  IGD: 'Dividends intragroup',
  IGT: 'INTER GROUP TRANSFER',
  IID: 'Interest on debt intragroup',
  INS: 'Insurance services',
  IOD: 'Income on deposits',
  IOL: 'Income on loans',
  IPC: 'Charges for the use of intellectual property royalties',
  IPO: 'IPO Subscriptions',
  IRP: 'INTEREST RATE SWAP PAYMENTS',
  IRW: 'INTERST RATE UNWIND PAYMENTS',
  ISH: 'Income on investment funds shares',
  ISL: 'Interest on securities more than a year',
  ISS: 'Interest on securities less than a year',
  ITS: 'Computer services',
  LAS: 'Leave Salary',
  LDL: 'Debt instruments intragroup loans, deposits in the UAE (above 10% shares)',
  LDS: 'Debt instruments intragroup securities in the UAE',
  LEA: 'Leasing abroad',
  LEL: 'Leasing in the UAE',
  LIP: 'Loan Interest Payments',
  LLA: 'Loans - Drawings or Repayments on loans extended to nonresidents – Long term',
  LLL: 'Loans - Drawings or Repayments on foreign loans extended to residents – Long term',
  LNC: 'Loan Charges',
  MCR: 'Monetary Claim Reimbursements',
  MWI: 'MOBILE WALLET CARD CASH-IN',
  MWP: 'MOBILE WALLET CARD PAYMENTS',
  OAT: 'Own Account Transfer',
  OTS: 'Other modes of transport (INCLUDING Postal and courier services)',
  OVT: 'Overtime',
  PIP: 'Profits on Islamic products',
  PMS: 'Professional and management consulting services',
  PPA: 'Purchase of real estate abroad from residents',
  PPL: 'Purchase of real estate in the UAE from non-residents',
  PRP: 'PROFIT RATE SWAP PAYMENTS',
  PRR: 'Profits or rents on real estate',
  PRS: 'Personal, cultural, audiovisual and recreational services',
  PRW: 'PROFIT RATE UNWIND PAYMENTS',
  RDA: 'Reverse debt instruments abroad',
  RDL: 'Reverse debt instruments in the UAE',
  RDS: 'Research and development services',
  REA: 'Reverse equity share abroad',
  REL: 'Reverse equity share in the UAE',
  RFS: 'Repos on foreign securities',
  RLS: 'Repos on securities issued by residents',
  RNT: 'Rent Payments',
  SAA: 'Salary Advance',
  SAL: 'Salary (Compensation of employees)\\nInclude the month and date in MMMYYYY format',
  SCO: 'Construction',
  SLA: 'Loans - Drawings or Repayments on loans extended to nonresidents – Short term',
  SLL: 'Loans - Drawings or Repayments on foreign loans extended to residents – Short term',
  STR: 'Travel',
  STS: 'Sea transport',
  SVI: 'STORED VALUE CARD CASH‐IN',
  SVP: 'STORED VALUE CARD PAYMENTS',
  TAX: 'Tax Payment\\nInclude TRN number (the VAT registration number) or any other information',
  TCP: 'Trade credits and advances payable',
  TCR: 'Trade credits and advances receivable',
  TCS: 'Telecommunication services',
  TKT: 'Tickets',
  TOF: 'Transfer of funds between persons Normal and Juridical',
  TTS: 'Technical, trade‐related and other business services',
  UTL: 'Utility Bill Payments'
};
